import "./index.scss";
import { PRESS_MENTIONS_LINKS } from "./utils/constants";

export const TestimonialsArticles = () => (
  <div className="testimonials-articles">
    <div className="container">
      {PRESS_MENTIONS_LINKS.map(({ title, url, backgroundPosition }) => (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a
          className="article"
          key={title}
          href={url}
          target="_blank"
          rel="noreferrer"
          title={title}
          alt={title}
          style={{ backgroundPosition }}
          aria-label={title}
        />
      ))}
    </div>
  </div>
);
